export class Partenariat {
  public _id:String;
  public website: String;
  public image:String;
  public type : String ;
  constructor(){}
}
